import { ReactNode, memo } from 'react';
import { FormControl, InputBaseProps, InputBase, InputLabel, Box, FormHelperText } from '@mui/material';
import { ControllerRenderProps, FieldValues, useController } from 'react-hook-form';
import { reverseThousandSeparator, separateThousands } from 'helpers/utils/number';

interface Props extends Omit<InputBaseProps, 'label'> {
  label: string | ReactNode;
  hookForm?: ControllerRenderProps<FieldValues, string>;
}

const CurrencyInput = memo(
  ({ label, hookForm, ...props }: Props) => {
    const { fieldState } = useController({ name: hookForm?.name ?? '' });

    return (
      <FormControl sx={{ pt: 2, mb: 2 }} fullWidth={props.fullWidth} error={Boolean(fieldState.error?.message)}>
        <InputLabel shrink htmlFor={props.name}>
          {label}
        </InputLabel>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              backgroundColor: 'surface.100',
              border: '1px solid lightgrey',
              borderRadius: 1,
              color: 'surface.700',
              px: 1,
              mt: 1,
              display: 'flex',
              alignItems: 'center',
              height: 42
            }}
          >
            Rp
          </Box>
          <InputBase
            id={props.name}
            {...props}
            {...hookForm}
            onChange={(e) => {
              hookForm?.onChange(reverseThousandSeparator(e.target.value));
            }}
            value={separateThousands(hookForm?.value as string)}
            sx={{ pt: 1, ...props.sx }}
          />
        </Box>
        <FormHelperText sx={{ m: 0 }}>{fieldState.error?.message}</FormHelperText>
      </FormControl>
    );
  },
  (prevProps, nextProps) => prevProps.hookForm?.value === nextProps.hookForm?.value
);

CurrencyInput.displayName = 'CurrencyInput';

export default CurrencyInput;
